import React from "react";
import { LuArrowUpRight } from "react-icons/lu";
import ProjectImg1 from "../../assets/Established.png";

export const Projects = () => {
    const projects = [
        {
            image: ProjectImg1,
            title: "Thermal power station",
            description: "Complete boiler installation and pipeline integration",
            tags: ["Boiler erection", "Pipeline systems", "Insulation work"],
        },
        {
            image: ProjectImg1,
            title: "Petrochemical refinery",
            description: "Fabrication and installation of process piping",
            tags: ["Boiler erection", "Pipeline systems", "Insulation work"],
        },
        {
            image: ProjectImg1,
            title: "Steel Manufacturing",
            description: "Structural fabrication and heavy equipment assembly",
            tags: ["Boiler erection", "Pipeline systems", "Insulation work"],
        },
        {
            image: ProjectImg1,
            title: "Thermax Boiler Erection",
            description: "Complete boiler installation and pipeline integration",
            tags: ["Boiler erection", "Pipeline systems", "Insulation work"],
        },
        {
            image: ProjectImg1,
            title: "Pipeline Installation",
            description: "Fabrication and installation of process piping",
            tags: ["Boiler erection", "Pipeline systems", "Insulation work"],
        },
        {
            image: ProjectImg1,
            title: "TPH Boiler RG Conversion",
            description: "Structural fabrication and heavy equipment assembly",
            tags: ["Boiler erection", "Pipeline systems", "Insulation work"],
        },
    ];

    return (
        <section className="w-full px-4  md:py-14 md:px-10 bg-white">
            <div className="max-w-7xl px-6 mx-auto">

                {/* Heading */}
                <div className="text-center space-y-4 mb-12">
                    <p className="text-sm text-gray-500">Work</p>
                    <h2 className="text-3xl md:text-5xl font-bold text-gray-900">
                        Recent projects
                    </h2>
                    <p className="text-gray-600 max-w-2xl mx-auto">
                        We are currently executing multiple industrial projects across different sectors, delivering reliable and high-quality pipeline and boiler solutions.
                    </p>
                </div>

                {/* Grid */}
                <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
                    {projects.map((item, index) => (
                        <div
                            key={index}
                            className="rounded-2xl overflow-hidden border hover:shadow-lg transition group bg-white"
                        >
                            {/* Image */}
                            <img
                                src={item.image}
                                alt={item.title}
                                className="w-full h-52 object-cover group-hover:scale-105 transition duration-300"
                            />

                            {/* Content */}
                            <div className="p-5">
                                <h3 className="text-lg font-semibold text-gray-900">
                                    {item.title}
                                </h3>

                                <p className="text-gray-500 text-sm mt-2">
                                    {item.description}
                                </p>

                                {/* Tags */}
                                <div className="flex flex-wrap gap-2 mt-3">
                                    {item.tags.map((tag, i) => (
                                        <span
                                            key={i}
                                            className="text-xs px-3 py-1 border rounded-full text-gray-600"
                                        >
                                            {tag}
                                        </span>
                                    ))}
                                </div>

                                {/* CTA */}
                                <button className="group mt-4 text-orange-500 text-sm flex items-center gap-1 font-medium">
                                    Know More
                                    <LuArrowUpRight className="group-hover:translate-x-1 group-hover:rotate-45 transition" />
                                </button>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Bottom Button */}
                <div className="flex justify-center mt-10">
                    <button className="border border-orange-500 text-orange-500 px-6 py-2 rounded-md hover:bg-orange-50 transition">
                        View All Projects
                    </button>
                </div>

            </div>
        </section>
    );
};

